import "react-toastify/dist/ReactToastify.css";
import Customer from "./pages/Customer";
import Dashboard from "./pages/Dashboard";
import ForgotPassword from "./pages/ForgotPassword";
import History from "./pages/History";
import ResetPassword from "./pages/ResetPassword";
import Signup from "./pages/Signup";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import CMSPage from "./pages/CMSPage";
import TermsAndConditions from "./pages/T&C";
import Privacy from "./pages/Privacy";
import Predictions from "./pages/Predictions";
import Tournaments from "./pages/Tournaments";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Navigate to="/login" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/customers" element={<Customer />} />
        <Route path="/history" element={<History />} />
        <Route path="/predictions" element={<Predictions />} />
        <Route path="/tournaments" element={<Tournaments />} />
        <Route path="/cms-page" element={<CMSPage />} />
        <Route path="/login" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<Privacy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
